import { useEffect, useState } from "react";
import Blog from "./Blog";
import axios from "axios";
import UseFetchBlog from "../../hooks/useFetchBlog";
import "./blogs.css";

const Blogs = () => {
  const { fetchBlogs, setError, loading, error, success, blogs, setBlogs } =
    UseFetchBlog();

  useEffect(() => {
    fetchBlogs();
  }, []);

  return (
    <div className="blogs-page">
      <div className="blogs-header">
        <h1 className="blogs-title">ILP Blog</h1>
        <p className="blogs-subtitle">
          Stay updated with the latest announcements, interview schedules, and
          selections
        </p>
      </div>
      <div className="blogs-container">
        {blogs && blogs.map((blog) => <Blog key={blog.id} blog={blog} />)}
      </div>
    </div>
  );
};

export default Blogs;
